import React from 'react';
import { AlertProps } from 'theme-ui';
import { Box, Alert } from '../core';
import { MouseoverTooltip, TooltipIcon, IIcons } from '../Tooltip';

export const Whitelist = (props: AlertProps): JSX.Element | null => {
  return (
    <MouseoverTooltip
      placement="top"
      width="auto"
      text="Vault deposits are currently only available for whitelisted wallets."
    >
      <Alert {...props} variant="buttons.disabled">
        <Box m="auto">
          This vault is private. <TooltipIcon icon={IIcons.HELP} />
        </Box>
      </Alert>
    </MouseoverTooltip>
  );
};
